import { gql } from "@stadium/services/apollo-client";

export const fetchShopListing = gql`
  query GetStore($perPage: Int, $templateSearchQuery: String, $marketingCategoryId: Int)
  @api(name: "search") {
    storeSearch(
      templateSearchQuery: $templateSearchQuery
      marketingCategoryId: $marketingCategoryId
      perPage: $perPage
    ) {
      storeName: name
      tags
      topBannerImage
      sampleProductsImage
      longDescription
      shortDescription
      storeCode: code
      storeNumber: number
      feUrl: feUrlWithWorkspaceSlug
      marketingCategories {
        id
        position
      }
      highlightName
      type
      id
    }
  }
`;
